
import React, { useEffect, useState } from 'react'
import { Form } from 'react-router-dom'
import axios from '../../API/axios';
import toast from 'react-hot-toast';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Flatpickr from 'react-flatpickr'
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ErrorToast from '../ErrorToast';
import WarningToast from '../WarningToast';
import SuccessToast from '../SuccessToast';

const CCVAchievement = ({ showCCVAchivement, handleCloseCCVAchivement, ExperienceId, getUserCcv }) => {
    const sessionId = localStorage.getItem("sessionId");
    const [achivement, setAchivement] = useState('')
    const [AchivementDate, setAchivementDate] = useState('')

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);


    const AddAchivement = async () => {
        const data =
        {
            "deviceType": "Web",
            "sessionId": sessionId,
            "ccvExpId": ExperienceId,
            "achievement": achivement,
            "achivementDate": AchivementDate === '' ? '' : moment(AchivementDate).format("YYYY-MM-DD"),
        }
        try {
            await axios.post(`CcvAction/AddCcvExperienceAcheivement`, data).then((resData) => {
                console.log('resData', resData);
                // toast.success(resData.data.message)
                getUserCcv()
                handleCloseCCVAchivement()
                setAchivement('')
                setToastMessage(resData.data.message);
                setShowToast(true);
            });
        } catch (error) {
            console.log(error);
            // toast.error(error.response.data.message);
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    useEffect(() => {
        if (showCCVAchivement) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            document.body.classList.add('modal-open'); // When a modal opens
        } else {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = '';
            document.body.classList.remove('modal-open'); // When a modal closes
        }
    }, [showCCVAchivement]);
    const preventYearScroll = (datePickerInstance) => {
        const yearElement = datePickerInstance.currentYearElement;
        if (yearElement) {
            yearElement.addEventListener("wheel", (e) => {
                e.preventDefault(); // Stops mouse scroll
            });
        }
    };
    return (
        <>
            {showCCVAchivement && (
                <div className="modal fade show" tabIndex="-1" achivement="dialog" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered" achivement="document">
                        <div className="modal-content">
                            <div className='setting-header d-flex justify-content-between align-items-center'>
                                <h6>Add Achivement</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer" onClick={handleCloseCCVAchivement}
                                />
                            </div>
                            <Form>
                                <div className='row p-4 settings CreateCompany'>
                                    <div className="col-md-12 mt-2">
                                        <label htmlFor="about">Achivement</label>
                                        <input type='text'
                                            value={achivement}
                                            onChange={e => setAchivement(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label htmlFor="about">Achivement Date</label>
                                        <Flatpickr className='form-control' value={AchivementDate} onChange={date => setAchivementDate(date[0])} id='dob' options={{
                                            maxDate: "today", // Disables future dates
                                            onReady: (selectedDates, dateStr, instance) => {
                                                preventYearScroll(instance); // Call the function to stop scroll on year
                                            },
                                            onOpen: (selectedDates, dateStr, instance) => {
                                                preventYearScroll(instance); // Also prevent scroll when the picker opens
                                            },
                                        }} />
                                    </div>


                                    <div className='text-end mt-4'>
                                        <button type="button" className="mainBtn1"
                                            onClick={AddAchivement}
                                            style={{ width: '170px' }}
                                        >Add Achivement</button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            )
            }

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    )
}

export default CCVAchievement